export default "__VITE_ASSET__C28s$sx3__ 640w, __VITE_ASSET__FWu8VFdC__ 1024w, __VITE_ASSET__Duil06Nj__ 1280w";